<template>
    <v-dialog v-model="getEditKioskConfig.show" width="35%" persistent>
        <v-card>
            <v-card-title class="d-flex align-center justify-center">Edit Kiosk Configuration</v-card-title>
            <v-card-text>
                <v-select outlined v-model="selectedEfileModules" :items="efileModules" multiple item-text="name"
                    item-value="alias" chips></v-select>
            </v-card-text>
            <v-card-actions class="d-flex align-center justify-center">
                <v-btn width="150" color="primary" @click="saveConfig">Save Config</v-btn>
                <v-btn width="150" color="error" @click="$store.commit('closeEditKioskConfig')">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import modules from '../../../store/modules';

export default {
    name: "editKioskConfig",
    data() {
        return {
            selectedEfileModules: [],
            efileModules: [{ name: "Civil & Family", alias: "civil", link: "https://dksuperiorclerk.com/civil/" }, { name: "Criminal", alias: "criminal", link: "https://dksuperiorclerk.com/criminal/" },
            { name: "Appeals", alias: "appeal", link: "https://dksuperiorclerk.com/appeals/" }, { name: "Family Law", alias: "family", link: "https://dekalbsuperiorcourt.com/family-law2/the-center/" },
            { name: "Trade Name", alias: 'trade', link: "https://dksuperiorclerk.com/trade-names/" }, { name: "Odyssey Navigator", alias: 'odyssey', link: "https://ars-custom-action/?openLocalApp=TylerNavigator" }],
        }
    },
    computed: {
        ...mapGetters(["getEditKioskConfig"])
    },
    watch: {
        getEditKioskConfig(newVal) {
            if (newVal.show) {
                this.selectedEfileModules = []
                console.log('New val at edit kiosk config: ', newVal)
                newVal.kioskInfo.data().modules.forEach(mod => {
                    console.log('Selected Module: ', mod)
                    this.selectedEfileModules.push(this.efileModules.filter(emod => emod.alias === mod)[0])
                })
            }
        }
    },
    methods: {
        saveConfig() {
            //coming soon
            console.log('What is the kiosk config: ', this.selectedEfileModules)
            let moduleList = this.selectedEfileModules.filter(emod => emod !== undefined)
            this.$store.dispatch("updateEfileModules", {
                kioskId: this.getEditKioskConfig.kioskInfo.id,
                modules: moduleList
            }).then(() => {
                this.$store.dispatch("showSnackBar", {
                    text: 'Efile Display modules updated',
                    color: "success",
                });
                this.$store.commit('closeEditKioskConfig')
            })
        }
    }
}
</script>